import { IInteractiveState, IMeta } from '@bees-web/core/types'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import {
  trackHomepageBannerClicked,
  trackHomepageBannerViewed,
} from '../actions/banners'
import { IHomeState } from '../interfaces'

export const bannerOnClickSegment = (
  meta: IMeta,
  dispatch: ThunkDispatch<IInteractiveState<IHomeState>, {}, AnyAction>
) => {
  const {
    module,
    screen,
    vendorId,
    storeId,
    id,
    name,
    tags,
    quantity,
    imageUrl,
    position,
    url,
    referrer,
    type,
  } = meta
  dispatch(
    trackHomepageBannerClicked({
      banner_id: id,
      banner_module: module,
      banner_name: name,
      banner_tags: tags,
      banner_type: type,
      banners_quantity: quantity,
      brand: null,
      image_url: imageUrl,
      position,
      screen_name: screen,
      store_id: storeId,
      url,
      vendorId,
      referrer,
    })
  )
}

export const bannerOnLoadSegment = (
  meta: IMeta,
  dispatch: ThunkDispatch<IInteractiveState<IHomeState>, {}, AnyAction>
) => {
  const {
    module,
    screen,
    vendorId,
    storeId,
    id,
    name,
    tags,
    quantity,
    imageUrl,
    position,
    url,
    referrer,
    type,
  } = meta
  dispatch(
    trackHomepageBannerViewed({
      banner_id: id,
      banner_module: module,
      banner_name: name,
      banner_tags: tags,
      banner_type: type,
      banners_quantity: quantity,
      brand: null,
      image_url: imageUrl,
      position,
      screen_name: screen,
      store_id: storeId,
      url,
      vendorId,
      referrer,
    })
  )
}
